import script from "./LenderSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./LenderSlider.vue?vue&type=script&setup=true&lang=ts"

import "./LenderSlider.vue?vue&type=style&index=0&id=6abb0668&lang=css"

const __exports__ = script;

export default __exports__